import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const overview: RouteRecordItem = {
  path: '/overview',
  name: 'Overview',
  component: LAYOUT,
  redirect: { name: 'OverviewDetail' },
  meta: {
    orderNo: 1,
    icon: 'dashicons:dashboard',
    title: t('routes.overview.概览'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'detail',
      name: 'OverviewDetail',
      component: () => import('@/pages/overview/index.vue'),
      meta: {
        title: t('routes.overview.概览'),
      },
    },
  ],
}

export default overview
